/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Pos_BottomInputs */

const vi_shop_home_pos_bottom = /** @type {(inputs: Shop_Home_Pos_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dưới`)
};

/**

* @param {Shop_Home_Pos_BottomInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_pos_bottom = /** @type {((inputs?: Shop_Home_Pos_BottomInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Pos_BottomInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_pos_bottom(inputs)
});